import React from 'react'
import { Button } from "react-bootstrap";
import NoResults from '../../../../components/NoResults/NoResults'

export default function CategoriesTable({
	categories,
	sampleProduct,
	API_URL,
	setForm,
	sortBy = "none",
	handleHeaderSort = () => {},
}) {
	const getSortState = () => {
		const [field, dir] = String(sortBy || "").split("|");
		return { field, dir: (dir || "").toUpperCase() };
	};

	const sortState = getSortState();

	const arrow = (field) => {
		if (sortState.field !== field) return "";
		return sortState.dir === "ASC" ? " ▲" : " ▼";
	};

	const getCategoryColor = (color) => {
		const value = String(color || "").trim();

		return /^#[0-9A-F]{6}$/i.test(value)
			? value.toUpperCase()
			: null;
	};

	return (
		<div className='border'>
			<div
				className='custom-scroll overflow-auto'
				style={{ maxHeight: "calc(100vh - 170px)" }}
			>
				<table className="table table-striped">
					<thead className="headers-stick-machines">
						<tr>
							<th style={{ width: "150px" }}></th>

							<th className='align-middle'
								style={
									process.env.REACT_APP_LOCAL_DB === "true"
										? {}
										: {
												cursor: "pointer",
												userSelect: "none"
										  }
								}
								onClick={
									process.env.REACT_APP_LOCAL_DB === "true"
										? undefined
										: () => handleHeaderSort("Name")
								}
							>
								Nazwa{arrow("Name")}
							</th>

							<th className='align-middle pe-none' style={{ width: "200px" }}>
								Kolor
							</th>

							<th
								className="p-2 align-middle"
								style={{ width: "100px" }}
							>
								<div className="d-flex flex-column align-items-center">
									<i
										className="btn btn-outline-secondary fas fa-plus"
										onClick={() => setForm('new')}
									/>
								</div>
							</th>
						</tr>
					</thead>

					<tbody>
						{categories.map((category, idx) => {
							const color = getCategoryColor(category.Color);

							return (
								<tr key={idx}>
									<td>
										<img
											src={category.Image ? `${API_URL}/${category.Image}` : sampleProduct}
											onError={(evt) =>
												(evt.target.src = sampleProduct)
											}
											alt={category.Name}
											width="48px"
											height="48px"
										/>
									</td>

									<td style={{ wordBreak: "break-word" }}>
										{category.Name}
									</td>

									<td className="align-middle">
										{color ? (
											<div className="d-flex align-items-center">
												<div
													style={{
														width: "32px",
														height: "32px",
														minWidth: "32px",
														backgroundColor: color,
														border: "1px solid rgba(0, 0, 0, 0.2)",
														borderRadius: "4px",
														marginRight: "10px",
													}}
												/>

												<span
													style={{
														fontFamily: "monospace",
														fontWeight: 500,
													}}
												>
													{color}
												</span>
											</div>
										) : (
											<span className="text-muted">
												-
											</span>
										)}
									</td>

									<td>
										<Button
											variant='btn btn-outline-primary btn-sm'
											onClick={() =>
												setForm(category.CategoryId)
											}
										>
											Edytuj
										</Button>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>

				{categories?.length === 0 && <NoResults />}
			</div>
		</div>
	);
}